import React from 'react';
import Logo from '../../../assets/images/Logo (Oya Concierge).png';
import { useMobile } from '../../../hooks/useMobile';

export const EmailConfirmation = () => {
    const isMobile = useMobile();



    const screenStyle: React.CSSProperties = {
        minHeight: '100vh',
        width: '100%',
        backgroundColor: '#FFFFFF',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: 'Manrope, sans-serif'
    };

    const headerStyle: React.CSSProperties = {
        backgroundColor: '#0A1A2F', 
        padding: '30px 0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
    };

    const cardStyle: React.CSSProperties = {
        backgroundColor: '#E6E8EC', 
        width: isMobile ? '80%' : '60%',
        margin: '60px auto',
        padding: '40px 30px',
        borderRadius: '24px',
        textAlign: 'center',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)'
    };

    const otpInputStyle: React.CSSProperties = {
        width: '100%',
        fontSize: '32px',
        padding: '10px',
        fontFamily: 'Manrope", sans-serif',
        fontWeight: '700',
        textAlign: 'center',
        border: 'none',
        borderRadius: '8px',
        backgroundColor: '#D1D5DB',
        color: '#000',
        outline: 'none',
        letterSpacing: '20px'
    };

    return (
        <div style={screenStyle}>
            <div style={headerStyle}>
                <img src={Logo} alt="Oya Logo" style={{ width: isMobile ? '50%' : '30%' }} />
            </div>

            <div style={cardStyle}>
                <h1 style={{ fontSize: '24px', fontWeight: '700', color: '#1F2933', marginBottom: '10px', textAlign: 'left' }}>
                    Confirm Your Email Address
                </h1>
                <p style={{ fontSize: '16px', color: '#6B7280', marginBottom: '80px', textAlign: 'left' }}>
                    Thanks for signing up for Oya Concierge. To complete your account setup, please use the verification code below.
                </p>

                <p style={{ fontSize: '18px', fontWeight: '700', color: '#102751', marginBottom: '20px' }}>
                    Your Verification Code
                </p>
                <input
                    type="text"
                    maxLength={6}
                    style={otpInputStyle}
                />

                <p style={{ fontSize: '18px', color: '#14213D66', margin: '10px 0px 40px' }}>
                    This code will expire in 10 minutes.
                </p>

                <button
                    style={{
                        width: '100%',
                        padding: '16px',
                        backgroundColor: '#1F2937',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '12px',
                        fontSize: '16px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        margin: '40px 0px 25px'
                    }}
                >
                    Verify my account
                </button>

                <p style={{ fontSize: '18px', color: '#14213D66', fontWeight: '700' }}>
                    If you didn't request this code, you can safely ignore this email. Your account will remain secure.
                </p>
            </div>
        </div>
    );
};